module.exports = __webpack_public_path__ + "img/defkf7.7b328990.png";